<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-6 align-self-center">
      <h2>{{$t("navigations.schedule task")}}</h2>
    </div>
    <div class="col-6 d-flex align-items0c-center px-0">
      <div>
        <label v-if="versionList!=null" class="mb-0" for="interimVersion">{{ $t("navigations.interim version")}}</label>
        <select class="form-select" @change="setVersionNo()" name="interimVersion" id="interimVersion" v-model="interimVersion">
          <option value="">
            {{ $t("navigations.none") }}
          </option>
          <option v-for="version in versionList" :key="version" :value="version">
            {{ version }}
          </option>
        </select>
      </div>   
      <button  @click="expandCollapse('expand')" type="button" class="save_btn py-2 px-3" 
       >
        <div >{{
        $t("navigations.overall history") }}</div>
      </button>
      <button @click="openModal()" type="button" class="save_btn py-2 px-3" 
      >
        <div>{{
        $t("navigations.add schedule task") }}</div>
      </button>
    </div>
  </div>

  <div>
    <div class="wrapper wrapper-content">
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">{{$t("navigations.schedule task")}}</h5>    
        </div>
        <div class="ibox-content">
          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.task name") }}
                    </div>
                  </th>
                  <th
                    class="sort_block"
                    @click="SortSelected('CreatedAt', 4)"
                    id="4"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.task status") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.next schedule run") }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.run type") }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.created by") }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.task created datetime") }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.task expire datetime") }}
                    </div>
                  </th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <!-- <tbody>
                <tr
                  v-for="audit in auditList"
                  :key="audit.id"
                  :value="audit.id"
                >
                </tr>
              </tbody> -->
            </table>
            <!------ pagination -------->
            <!-- <div class="row mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div
                  class="dataTables_paginate paging_simple_numbers pagination float-right"
                >
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination
                      v-model="currentPage"
                      :pages="totalItems"
                      :range-size="1"
                      active-color="#618bd7"
                      @update:modelValue="loadPage"
                    />
                  </div>
                </div>
              </div>
            </div> -->
            <!---Pagination ends-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <customModal v-if="openScheduleModal == true" :containerxl=true :bodymd="true" :footerShow="true" @closeModal="closeScheduleModal('run')">
    <template #title>
      {{ $t("navigations.custom program run") }}
    </template>
    <template #body>
      <div class="row">
        <div class="col-6">
          <h6>{{ $t('navigations.analysis tree') }}</h6>
          <div class="height-450 mt-4">
            <ul class="modal-tree pl-2">
          <li v-for="(node, index) in Object.keys(treeModal)" :key="`treeModal-${index}`">
            {{ treeModal._id }}
            <input class="mr-2" type="checkbox" :id="`treeModal-${index}`" v-model="rootChecked[`treeModal-${index}`]"
              @change="toggleChildren(treeModal[node], index,`treeModal-${index}`)" />
            <label class="modal_tree_label" :for="`treeModal-${index}`">{{ treeModal[node].Headingindex }} {{ node }}</label>
            <ul v-if="treeModal[node].Reports.length != 0">
              <li v-for="(childlabels, vindex) in treeModal[node].Reports" :key="`treeModal-${index}-${vindex}`">
                <input class="mr-2" type="checkbox" @change="toggleChild(childlabels.Programms,index, vindex, $event.target.checked,)" :id="`treeModal-${index}-${vindex}`"
                  v-model="childrenChecked[`treeModal-${index}-${vindex}`]" />
                <label class="modal_tree_label" :for="`treeModal-${index}-${vindex}`">{{ childlabels.Subindex }} {{
                  childlabels.Reportname }} </label>
                 <ul class="pl-3">            
                  <li v-for="(value,subindex) in childlabels.Programms" :key="value.ReportId" >
                    <input class="mr-2" type="checkbox" :id="`treeModal-${index}-${vindex}-${subindex}`"
                    v-model="subchildrenChecked[`treeModal-${index}-${vindex}-${subindex}`]" @change="toggleSubChild(index, vindex, subindex,$event.target.checked,value.Version,value)" />        
                    <label :for="`treeModal-${index}-${vindex}-${subindex}`"
                    class="modal_tree_label px-1"><span v-if="value.Status && value.ReportType!=null">{{ value.ReportType[0] }}  </span> {{ childlabels.Subindex }}<span>.</span>{{value.Version}} <span>{{ value.ProgramName }}
                    </span>
                    </label>
                     
                  </li>
              
              </ul>
              </li>
            </ul>
          </li>
        </ul>
          </div>
        </div>
        <div class="col-6">
          <h6>{{ $t('navigations.selected entries') }}</h6>
          <div class="mt-4" :class="{'height-450':selectedPrograms.length>10}">
            <div class="pl-2">
              <div v-for="childlabels in selectedPrograms" :key="childlabels.report">
                
                <div class="d-flex" v-for="(value,subindex) in childlabels.programs" :key="value._id" >
                  <div role="button" class="cursor-pointer mr-2" @click.prevent="deleteProgram(childlabels.nodeIndex,childlabels.reportIndex,subindex,value.Version)">
                    <img class="delete-icon mb-1" src="../../assets/img/red_minus.svg" alt="remove program">  
                  </div>                    
                  <label :for="`selectedProgram-${subindex}`"
                  ><span v-if="value.Status && value.ReportType!=null">{{ value.ReportType[0] }}  </span> {{ childlabels.subIndex }}<span>.</span>{{value.Version}} <span v-if="value.ProgramName">{{ value.ProgramName }}</span>

                  </label>
                </div>
              </div>
            </div>
          </div>           
        </div>
      </div>     
    </template>
    <template #footer >
      <div class="col-12 text-center">
        <button type="button" class="save_btn px-5 position-relative" :disabled="loadingAssignBlock == true"
            @click.prevent="runMultiplePrograms()" :class="{ 'disabled-btn-cls': loadingAssignBlock == true }">
            <div class="toc-loader position-absolute"
            :class="{ 'opacity-0': loadingAssignBlock == false, 'opacity-1': loadingAssignBlock == true }">
            <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
            </div>
            <div :class="{ 'opacity-1': loadingAssignBlock == false, 'opacity-0': loadingAssignBlock == true }">{{
            $t("navigations.run") }}</div>
        </button>
      </div>   
    </template>
  </customModal>
</template>
<script src="./scheduleTask.js"></script>

<style>
.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}

.disabled-btn-cls {
  opacity: 0.6;
  pointer-events: none;
}
</style>
